<template>
  <div>
    <div v-if="!payload" class="flex flex-center" style="padding: 20px 0;">
      <van-loading size="80px" vertical>数据加载中...</van-loading>
    </div>
    <template v-else>
      <div class="com-page-title">
        <div class="inner">{{ $route.meta.title }}</div>
      </div>
      <template v-for="lst in payload.lordofmeritList" :key="lst.id">
        <!-- 超荐莲位 -->
        <template v-if="(categoryLength > 1 ? step == 1 : true) && lst.way?.indexOf('lianwei') != -1">
          <div v-for="(formItem, index) in formDatas[lst.id]" :key="index">
            <div class="com-card">
              <div class="com-card-title">往生者信息{{ formDatas[lst.id].length > 1 ? `(${index + 1})` : '' }}</div>
              <div class="com-card-content">
                <div class="com-form-wrap">
                  <van-form class="com-form-vertical" :ref="`form1-${index + 1}`">
                    <van-field
                      class="field-yellow"
                      v-model="formItem.deadList[0].deadAppellation"
                      :border="false"
                      readonly
                      clickable
                      label="往生者称谓"
                      placeholder="请选择往生者称谓"
                      :rules="[{ required: true, message: '请选择往生者称谓' }]"
                      @click="showAppellationPicker(index, lst.id, 1)"
                    >
                      <template #left-icon>仅限一人</template>
                    </van-field>
                    <van-field
                      v-model="formItem.deadList[0].deadName"
                      :border="false"
                      label="往生者姓名"
                      :placeholder="formItem.deadList[0].appellationData.placeholder"
                      :rules="[{ required: !((formItem.deadList[0].appellationData.appellation && formItem.deadList[0].appellationData.nameHolder) || ['夭折婴灵', '堕胎婴灵'].includes(formItem.deadList[0].appellationData.appellation)), message: '请填写往生者姓名' }]"
                      :disabled="formItem.deadList[0].appellationData.appellation && formItem.deadList[0].appellationData.nameHolder"
                    />
                    <van-field
                      v-model="formItem.deadList[1].deadAppellation"
                      readonly
                      :border="false"
                      label="往生者称谓（可选）"
                      placeholder="请选择往生者称谓"
                      :disabled="!formItem.deadList[0].appellationData.appellation || formItem.deadList[0].appellationData.relative.selectHolder"
                      @click="showAppellationPicker(index, lst.id, 2)"
                    >
                      <template #left-icon>仅夫妻关系可选</template>
                    </van-field>
                    <van-field
                      v-model="formItem.deadList[1].deadName"
                      :border="false"
                      label="往生者姓名（可选）"
                      :placeholder="formItem.deadList[1].appellationData?.placeholder"
                      :rules="[{ required: formItem.deadList[1].appellationData?.appellation && !formItem.deadList[1].appellationData?.selectHolder, message: '请选择往生者称谓' }]"
                      :disabled="!formItem.deadList[0].appellationData?.appellation || formItem.deadList[0].appellationData?.relative.selectHolder"
                    />
                  </van-form>
                </div>
              </div>
            </div>
            <div class="com-card">
              <div class="com-card-title">阳上（供奉人）信息{{ formDatas[lst.id].length > 1 ? `(${index + 1})` : '' }}</div>
              <div class="com-card-content">
                <div class="com-form-wrap">
                  <van-form class="com-form-vertical" :ref="`form2-${index + 1}`">
                    <van-field
                      v-model="formItem.name"
                      :border="false"
                      label="阳上(供奉人)姓名"
                      :placeholder="lst.surnameNumber > 1 ? formItem.deadList[0]?.appellationData.placeholder2 : '示例：XXX'"
                      :rules="[{ required: true, trigger: 'onBlur', message: '请填写姓名' }]"
                    >
                      <template #left-icon>
                        <span>{{ lst.surnameNumber > 1 ? `限${['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '拾'][lst.surnameNumber]}人以内` : '仅限一人' }}</span>
                      </template>
                    </van-field>
                    <van-field
                      v-model="formItem.mobile"
                      :border="false"
                      label="联系方式"
                      placeholder="请填写手机号码"
                      :rules="[{ required: true, trigger: 'onBlur', message: '请填写手机号码' }, { validator: $validate.phone, message: '手机号格式不正确' }]"
                    />
                  </van-form>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 延生禄位 -->
        <template v-if="(categoryLength > 1 ? step == 2 : true) && lst.way?.indexOf('luwei') != -1">
          <div v-for="(formItem, index) in formDatas[lst.id]" :key="index">
            <div class="com-card">
              <div class="com-card-title">供奉人信息{{ formDatas[lst.id].length > 1 ? `(${index + 1})` : '' }}</div>
              <div class="com-card-content">
                <div class="com-form-wrap">
                  <van-form class="com-form-vertical" :ref="`form3-${index + 1}`">
                    <van-field
                      v-model="formItem.name"
                      :border="false"
                      label="供奉人姓名"
                      placeholder="示例：XXX,XXX,XXX或XXX全家"
                      :rules="[{ required: true, trigger: 'onBlur', message: '请填写供奉人姓名' }]"
                    >
                      <template #left-icon>限三人或一人及全家</template>
                    </van-field>
                    <van-field
                      v-model="formItem.mobile"
                      :border="false"
                      label="联系方式"
                      placeholder="请填写手机号码"
                      :rules="[{ required: true, trigger: 'onBlur', message: '请填写手机号码' }, { validator: $validate.phone, message: '手机号格式不正确' }]"
                    />
                  </van-form>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div class="flex" style="padding: 0 20px 30px 20px;">
        <DefaultBtn style="margin-right: 20px" @click="previous">上一步</DefaultBtn>
        <DefaultBtn v-if="categoryLength > 1 && step == 1" @click="validForm">下一步</DefaultBtn>
        <DefaultBtn v-if="step == (categoryLength > 1 ? 2 : 1)" @click="validForm">支付</DefaultBtn>
      </div>
    </template>

    <van-popup v-model:show="showAppellation" :close-on-click-overlay="false" position="bottom">
      <van-picker
        visible-item-count="5"
        :columns="appellationList.map(v => v.appellation)"
        @confirm="v => handleAppellationSelect(v, 1)"
        @cancel="cancleAppellationPicker(1)"
      />
    </van-popup>
    <van-popup v-model:show="showAppellation2" :close-on-click-overlay="false" position="bottom">
      <van-picker
        visible-item-count="1"
        :columns="[formDatas[lockedForm.id][lockedForm.index]?.deadList[0]?.appellationData.relative].filter(v => !!v).map(v => v.appellation)"
        @confirm="v => handleAppellationSelect(v, 2)"
        @cancel="cancleAppellationPicker(2)"
      />
    </van-popup>
  </div>
</template>

<script>
  import appellationList from '@/assets/js/appellationList'
  import { WxPay } from '@/utils/Pay'
  // 超荐莲位表单项
  const lianWeiForm = {
    // 供奉人
    name: null,
    // 供奉人手机号
    mobile: null,
    // 往生
    deadList: [
      {
        deadAppellation: null,
        deadName: null,
        // 称谓信息
        appellationData: {}
      },
      {
        deadAppellation: null,
        deadName: null
      }
    ]
  }
  // 延生禄位表单
  const luWeiForm = {
    // 供奉人
    name: null,
    mobile: null
  }
export default {
  data () {
    let numbers = {}
    try {
      numbers = JSON.parse(this.$route.query.numbers)
    } catch (error) {
      
    }
    return {
      step: 1,
      payload: null,
      numbers,
      // 超荐莲位对应关系
      appellationList: appellationList.filter(v => !v.hide),
      // 选择往生者称谓
      showAppellation: false,
      showAppellation2: false,
      // 当前操作的表单信息
      lockedForm: {
        index: null,
        id: null
      },
      formDatas: {}
    }
  },
  mounted () {
    if (Object.keys(this.numbers)?.length) {
      this.getFaHuiInfo()
    } else {
      this.$toast('参数不合法！')
    }
  },
  computed: {
    // 表单有几类，单个禄位、单个莲位、二者都有
    categoryLength () {
      return Object.keys(this.formDatas).length
    }
  },
  methods: {
    // 称为选择
    handleAppellationSelect (value, sequence) {
      const selectedAppellation = appellationList.find(v => v.appellation == value)
      if (sequence == 1) {
        this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[0].appellationData = selectedAppellation
        this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[0].deadAppellation = value
        // 第一个发生变化，清空第二个
        this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[1].appellationData = {}
        this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[1].deadAppellation = null
        // 禁止名称写入的清空第一个名称
        if (selectedAppellation.nameHolder) {
          this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[0].deadName = null
        }
        // 没有对应关系的清空第二个名称
        if (selectedAppellation.relative.selectHolder) {
          this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[1].deadName = null
        }
        this.showAppellation = false
      } else {
        this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[1].appellationData = selectedAppellation
        this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[1].deadAppellation = selectedAppellation.appellation
        this.showAppellation2 = false
      }
    },
    // 显示称谓列表
    showAppellationPicker (index, formId, sequence) {
      this.lockedForm = {
        index,
        id: formId
      }
      if (sequence == 1) {
        this.showAppellation = true
      } else {
        try {
          if (this.formDatas[formId][index].deadList[0].appellationData.appellation && !this.formDatas[formId][index].deadList[0].appellationData.relative.selectHolder) {
            this.showAppellation2 = true
          }
        } catch(e) {}
      }
    },
    // 隐藏picker
    cancleAppellationPicker (sequence) {
      if (sequence == 1) {
        this.showAppellation = false
      } else {
        // 取消的时候还原之前的选择
        this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[1].appellationData = {}
        this.formDatas[this.lockedForm.id][this.lockedForm.index].deadList[1].deadAppellation = null
        this.showAppellation2 = false
      }
    },
    // 返回上一步
    previous () {
      if(this.step == 1) {
        return this.$router.back()
      }
      this.step --
    },
    // 支付
    pay () {
      let liveList = []
      for (let key in this.formDatas) {
        this.formDatas[key].forEach(formData => {
          // 莲位
          if (formData.way.indexOf('lianwei') != -1) {
            liveList.push({
              ...formData,
              deadList: formData.deadList.filter(v => !!v.deadAppellation)
            })
          } else {
            // 䘵位
            liveList.push(formData)
          }
        })
      }
      // 微信支付，因为该商户为子商户，没有回调功能，支付成功就完事了。。。
      new WxPay({
        liveList,
        // 法会订单
        type: 1,
        // 后台管理订单详情里面后到
        orderType: JSON.stringify({
          key: 'fawu-fahui-paiwei',
          pId: this.payload.id,
          isLordofmerit: true
        }),
        goodsNum: 1,
        // 支付类型
        payWay: 'JSAPI',
        // 商品id
        goodsId: this.payload.lordofmeritGoodsId,
        // 价格
        orderPrice: this.payload.price,
        // orderPrice: 0.01
      })
    },
    // 验证表单1
    validForm () {
      let pList = []
      // 一共3种表单
      for (let i = 1; i <= 3; i ++) {
        // 莲位加䘵位这和，最多上限lordofmeritNumber次
        for (let k = 1; k <= this.payload.lordofmeritNumber; k ++) {
          if (this.$refs[`form${i}-${k}`]?.length) {
            pList.push(new Promise((resolve, reject) => {
              this.$refs[`form${i}-${k}`][0].validate().then(err => {
                if (!err) {
                  resolve()
                } else {
                  reject()
                }
              }).catch(reject)
            }))
          }
        }
      }
      Promise.all(pList).then(() => {
        if (this.step == 1 && this.categoryLength > 1) {
          this.step ++
        } else {
          this.pay()
        }
      }).catch(() => {
        this.$toast('请填写登记信息')
      })
    },
    // 获取法会信息
    getFaHuiInfo () {
      this.$faWuApi.faHui.getItemData({
        id: this.$route.query.pId
      }).then(res => {
        if (res.success) {
          // 验证上一步传入的参数有效性
          if ( Object.keys(this.numbers).map(key => this.numbers[key]).reduce((t, v) => t + v) <= res.data.lordofmeritNumber) {
            this.payload = res.data
            // 根据传入的数量，显示对应的表单
            res.data.lordofmeritList.forEach(item => {
              if (this.numbers[item.id]) {
                this.formDatas[item.id] = new Array(this.numbers[item.id]).fill(null).map(() => Object.assign(
                  JSON.parse(JSON.stringify(item.way?.indexOf('lianwei') != -1 ? lianWeiForm : luWeiForm)),
                  {
                    way: item.way
                  }
                ))
              }
            })
          } else {
            this.$toast('牌位数量不一致')
          }
        } else {
          this.$toast(res.errMessage)
        }
      })
    }
  }
}
</script>